import { render, staticRenderFns } from "./smspolicy.vue?vue&type=template&id=2b88e064&scoped=true"
import script from "./smspolicy.vue?vue&type=script&lang=js"
export * from "./smspolicy.vue?vue&type=script&lang=js"
import style0 from "./smspolicy.vue?vue&type=style&index=0&id=2b88e064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b88e064",
  null
  
)

export default component.exports